
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[...query]",
      function () {
        return require("private-next-pages/shop/[...query].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[...query]"])
      });
    }
  